// extracted by mini-css-extract-plugin
export default {"question":"Question_question__jAdBD","stack":"Question_stack__H0K5X","buttons":"Question_buttons__SSWQp","reverseMobile":"Question_reverseMobile__eVAWx"};